import { apiFetch } from "src/utils/apiFetch";

export async function postProductItem(updatedFormData: Record<string, any>) {
  return await apiFetch("/item/create", "POST", updatedFormData);
}

//  Get Buyer Commission Fee

export async function getProductById(id: number) {
  try {
    const res = await apiFetch(`/item/get/${id}`);
    const data = res?.data;
    return data;
  } catch (error) {
    console.error("Error fetching product by Id:", error);
    throw error;
  }
}

export async function getBuyerCommissionFee() {
  try {
    const data = await apiFetch("/commission/get");
    const response = data?.data;
    return response?.buyer_protection_fee;
  } catch (error) {
    console.error("Error getting buyer commission fee:", error);
    throw error;
  }
}

// Like Product
export async function likeProduct(productId: number) {
  const userId = sessionStorage.getItem("user_id");
  return await apiFetch("/wishlist/create", "POST", {
    item_id: Number(productId),
    user_id: Number(userId),
  });
}

export async function updateProduct(id: number, updatedFormData: any) {
  try {
    const res = await apiFetch(`/item/update/${id}`, "PUT", updatedFormData);
    const data = res?.data;
    return data;
  } catch (error) {
    console.error("Error updating product:", error);
    throw error;
  }
}

export async function deleteMyItem(id: number) {
  const res = await apiFetch(`/item/delete/${id}`, "DELETE");
  return res;
}


export async function appliedFilterOnProducts(page: number, payload: any) {
  const res = await apiFetch(`/filter/products?page=${page}`, "POST", payload);
  const data = res?.data;
  return data;
}